// @ts-strict-ignore
import {SectionItem} from 'common/components/items-menu/types';
import {ChartType} from 'common/types/reports/bookmark';

import {ChartGroup, ChartTypeSelection} from './constants';

const GROUP_SORT_MAP: {[key in ChartGroup]: number} = {series: 0, bar: 1, standard: 2, special: 3};

type ChartSectionGroups = {[key in ChartGroup]: Array<SectionItem<ChartType, {chartGroup: ChartGroup}>>};

export function generateChartTypeGroups(chartItems: Array<SectionItem<ChartType>>) {
  // group chart type by report name (item.chartGroup)
  const chartGroups: ChartSectionGroups = chartItems.reduce(
    (acc, item) => {
      acc[ChartTypeSelection[item.value].chartGroup].push({
        ...ChartTypeSelection[item.value],
        ...item,
      });
      return acc;
    },
    {standard: [], special: [], bar: [], series: []},
  );

  const sortedSections = Object.entries(chartGroups)
    // make sure insight chart types are at the top
    .sort(([prevKey], [curKey]) => GROUP_SORT_MAP[prevKey] - GROUP_SORT_MAP[curKey])
    .map(([, items]) => ({items}));

  return sortedSections;
}
